import {
  CarouselAdditionInitializationBlock,
  forEachRegisteredCarouselController,
} from "../carousel-handles";
import { CarouselSliderItemNumberChangeEvent } from "../slider/carousel-slider-item-number-change-event";
import { findCarouselSliderRootElement } from "../controller/initialize-carousel-controller";
import { fetchCarouselSliderItems } from "../slider/slider-elements-list";
import { scheduleOptionalIdleImageLoad } from "./idle-image-load";
import { currentCarouselQuerySelectorAll } from "../selector/current-selector";

/**
 * Loads every image inside all carousel slide item sequentially when the user agent is idle.
 */
export const initializeIdleImageLoading: CarouselAdditionInitializationBlock = (
  carouselRootElement,
  controller
) => {
  let loadAbortController: AbortController | undefined;
  let isIntersecting = false;

  const triggerIdleImageLoading = () => {
    const abortController = loadAbortController ?? new AbortController();
    loadAbortController = abortController;
    for (const slideElement of fetchCarouselSliderItems(
      findCarouselSliderRootElement(carouselRootElement)
    )) {
      for (const imageElement of currentCarouselQuerySelectorAll<HTMLImageElement>(
        slideElement,
        'img[loading="lazy"]'
      )) {
        scheduleOptionalIdleImageLoad(imageElement, abortController.signal);
      }
    }
  };

  new IntersectionObserver(
    (intersections) => {
      for (const intersection of intersections) {
        isIntersecting = intersection.isIntersecting;

        if (!isIntersecting) {
          loadAbortController?.abort("root element went out of viewport");
          loadAbortController = undefined;
          continue;
        }

        triggerIdleImageLoading();
      }
    },
    {
      threshold: 0,
    }
  ).observe(carouselRootElement);

  controller.addEventListener(CarouselSliderItemNumberChangeEvent.KEY, () => {
    if (isIntersecting) {
      triggerIdleImageLoading();
    }
  });
};

forEachRegisteredCarouselController(initializeIdleImageLoading);
